import React, { useState, useRef } from "react";
import { TravelExpenseReport } from "../types/expense";
import HeaderPopup from "./HeaderPopup";

interface ReportHeaderProps {
  onReportInfoChange: (reportInfo: Partial<TravelExpenseReport>) => void;
  reportInfo: Partial<TravelExpenseReport>;
  onClearAllData: () => void;
  onClearAllExpenses: () => void;
  hasExpenses: boolean;
  onShowHistory: () => void;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({
  onReportInfoChange,
  reportInfo,
  onClearAllData,
  onClearAllExpenses,
  hasExpenses,
  onShowHistory,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const clearButtonRef = useRef<HTMLButtonElement>(null);

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
  ) => {
    const { name, value } = e.target;
    onReportInfoChange({
      ...reportInfo,
      [name]: value,
    });
  };

  return (
    <div className="report-header">
      <div className="report-header-title">
        <div className="header-title-content">
          <img
            src="/they_consulting_logo.png"
            alt="They Consulting Logo"
            className="consulting-logo"
          />
          <h2>Reisekostenabrechnung</h2>
        </div>
        <div className="header-actions">
          <button
            type="button"
            className="history-header-btn"
            onClick={onShowHistory}
            title="Verlauf anzeigen"
          >
            <i className="fas fa-history"></i>
            <span className="history-btn-text">Verlauf</span>
          </button>
          <button
            ref={clearButtonRef}
            type="button"
            className="clear-data-btn"
            onClick={() => setIsPopupOpen(!isPopupOpen)}
            title="Aktionen"
          >
            <i className="fas fa-ellipsis-v"></i>
          </button>
          <button
            type="button"
            className="toggle-btn"
            onClick={() => setIsExpanded(!isExpanded)}
            title={isExpanded ? "Details ausblenden" : "Details anzeigen"}
          >
            <i className="fas fa-user"></i>
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="report-info-form">
          <div className="form-section">
            <div className="form-group">
              <label htmlFor="employeeName">Name</label>
              <input
                type="text"
                id="employeeName"
                name="employeeName"
                value={reportInfo.employeeName || ""}
                onChange={handleInputChange}
                placeholder="Name eingeben"
              />
            </div>

            <div className="form-group">
              <label htmlFor="employeeStreet">Straße</label>
              <input
                type="text"
                id="employeeStreet"
                name="employeeStreet"
                value={reportInfo.employeeStreet || ""}
                onChange={handleInputChange}
                placeholder="Straße eingeben"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="employeeZipCode">PLZ</label>
                <input
                  type="text"
                  id="employeeZipCode"
                  name="employeeZipCode"
                  value={reportInfo.employeeZipCode || ""}
                  onChange={handleInputChange}
                  placeholder="PLZ eingeben"
                />
              </div>
              <div className="form-group">
                <label htmlFor="employeeCity">Ort</label>
                <input
                  type="text"
                  id="employeeCity"
                  name="employeeCity"
                  value={reportInfo.employeeCity || ""}
                  onChange={handleInputChange}
                  placeholder="Ort eingeben"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <HeaderPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        onClearAllData={onClearAllData}
        onClearAllExpenses={onClearAllExpenses}
        anchorElement={clearButtonRef.current}
        hasExpenses={hasExpenses}
      />
    </div>
  );
};

export default ReportHeader;
